export interface Customer {
  id?: number;
  name?: string;
  code?: string;
  branch?: string;
  taxId?: string;
  address?: string;
  showAsEnglish?: boolean;
  subdistrictId?: number;
  districtId?: number;
  provinceId?: number;
  zipcode?: string;
  phone?: string;
  email?: string;
  credit?: string;
  credit_days?: string;
}

export const defaultCustomer: Customer = {
  id: -1,
  name: '',
  code: '',
  branch: '',
  taxId: '',
  address: '',
  showAsEnglish: false,
  subdistrictId: -1,
  districtId: -1,
  provinceId: -1,
  zipcode: '',
  phone: '',
  email: '',
  credit: '',
  credit_days: '',
};

export interface CustomerInput {
  name?: string;
  code?: string;
  branch?: string;
  taxId?: string;
  address?: string;
  showAsEnglish?: boolean;
  subdistrictId?: number;
  districtId?: number;
  provinceId?: number;
  zipcode?: string;
  phone?: string;
  email?: string;
  credit?: string;
  credit_days?: number;
}
